module.exports = __webpack_public_path__ + "img/truck-empty.6d48b686.svg";